export default __webpack_public_path__ + "static/media/360-factory-visibility.85278cbd.svg";